import { render, staticRenderFns } from "./InternalDossierManualShipment.vue?vue&type=template&id=42b1d293&scoped=true"
import script from "./InternalDossierManualShipment.vue?vue&type=script&lang=js"
export * from "./InternalDossierManualShipment.vue?vue&type=script&lang=js"
import style0 from "./InternalDossierManualShipment.vue?vue&type=style&index=0&id=42b1d293&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42b1d293",
  null
  
)

export default component.exports